var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlinepayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.375 38.375H17.5114C16.1244 38.375 15 37.4236 15 36.25V21.375C15 20.2014 16.1244 19.25 17.5114 19.25H40.1136C41.5006 19.25 42.625 20.2014 42.625 21.375L42.625 25.625H46.4886C47.8756 25.625 49 26.6953 49 28.0156V42.3594C49 43.6797 47.8756 44.75 46.4886 44.75H23.8864C22.4994 44.75 21.375 43.6797 21.375 42.3594V38.375ZM23.5 25.2C22.0917 25.2 20.95 26.3417 20.95 27.75V35.825H17.55V21.8H40.075L40.075 25.2H23.5ZM35.1875 39.4375C37.5347 39.4375 39.4375 37.5347 39.4375 35.1875C39.4375 32.8403 37.5347 30.9375 35.1875 30.9375C32.8403 30.9375 30.9375 32.8403 30.9375 35.1875C30.9375 37.5347 32.8403 39.4375 35.1875 39.4375Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinepayments);
export default __webpack_public_path__ + "static/media/onlinepayments.a3a10ff308ddab70706d9f4df07cc7e8.svg";
export { ForwardRef as ReactComponent };